import React from 'react';
import PropTypes from 'prop-types';

const EyeSlashIcon = ({ color = '#18964E', width = 24, height = 24 }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M12 6.5C15.79 6.5 19.17 8.63 20.82 12C20.23 13.18 19.4 14.21 18.41 15.03L19.82 16.44C21.21 15.23 22.31 13.74 23 12C21.27 7.61 17 4.5 12 4.5C10.6 4.5 9.26 4.75 8 5.2L9.17 6.37C10.07 6.4 11.03 6.5 12 6.5ZM10.56 6.88L12.67 9C13.8 9.2 14.72 10.13 14.93 11.26L17.04 13.37C17.33 12.95 17.57 12.5 17.77 12C16.12 8.63 12.74 6.5 8.95 6.5C9.47 6.5 10.03 6.66 10.56 6.88ZM1 3.27L3.28 5.55L3.74 6C2.08 7.3 0.78 9 0 11C1.73 15.39 6 18.5 11 18.5C12.55 18.5 14.03 18.2 15.38 17.66L15.8 18.08L18.73 21L20 19.73L2.27 2L1 3.27ZM7.53 9.8L9.08 11.35C9.03 11.56 9 11.78 9 12C9 13.66 10.34 15 12 15C12.22 15 12.44 14.97 12.65 14.92L14.2 16.47C13.53 16.8 12.79 17 12 17C9.24 17 7 14.76 7 12C7 11.21 7.2 10.47 7.53 9.8ZM11.84 9.02L14.99 12.17L15.01 12.01C15.01 10.35 13.67 9.01 12.01 9.01L11.84 9.02Z" 
      fill={color}
    />
  </svg>
);

EyeSlashIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default EyeSlashIcon; 